import {Component, ElementRef, HostBinding, Input, OnDestroy, OnInit, Renderer2, ViewChild, ViewContainerRef} from '@angular/core';
import {Router} from "@angular/router";

import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {HanjaWordMixin} from "../../mixin/hanja-word.mixin";


@Component({
  selector: 'app-hanja-content',
  templateUrl: './hanja-content.component.html',
  styleUrls: ['./hanja-content.component.scss']
})
export class HanjaContentComponent extends HanjaWordMixin implements OnInit, OnDestroy {
  @ViewChild('container', {read: ViewContainerRef}) container!: ViewContainerRef;
  @Input() hanjas?: string;
  @Input() selected: string | null = null;
  @Input() small: boolean = false;
  @Input() hangul?: string;    // 음 (1글자, 예: "국")
  @Input() firstHun?: string;  // 대표 훈 (예: "나라")

  @HostBinding('class.small')
  get isSmall(): boolean {
    return this.small;
  }

  private unlisten: (() => void) | null = null;

  get chars(): string[] {
    return this.hanjas ? Array.from(this.hanjas) : [];
  }

  constructor(
    public override router: Router,
    public override dynamicSvc: DynamicComponentService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private globalEventSvc: GlobalEventService,
  ) {
    super(router, dynamicSvc);
  }

  ngOnInit() {
    this.unlisten = this.renderer.listen(this.elementRef.nativeElement, 'click', (event) => {
      const clickedElement = event.target as HTMLElement;

      if (clickedElement.classList.contains('hanja-txt')) {

        event.preventDefault();
        event.stopPropagation();
        this.globalEventSvc.Click(event, true);

        const hanja = clickedElement.textContent?.trim();
        if (!hanja) {
          console.error('HanjaContentComponent: Clicked element has no text content', {
            hanjas: this.hanjas,
            element: clickedElement.outerHTML
          });
          return;
        }

        this.OpenHanjaWord(hanja, this.container, this.hangul, this.firstHun).subscribe({
          next: (result) => {
            console.log('HanjaContentComponent.onClick(): result=', result);
          },
          error: (err) => {
            console.error('HanjaContentComponent: Failed to open hanja word popup', err);
          }
        });
      }
    });
  }

  ngOnDestroy() {
    if (this.unlisten) {
      this.unlisten();
      this.unlisten = null;
    }
  }
}
